import {useApi} from "@/requests/useApi";
import {getOperator, globalConfig, headers, Paths, UON} from "@/utils";
import {getPartyName} from "@/store/services/order/orderService";
import {getOrderParty} from "@/store/services/order/orderApi";
import { Picklist } from "@/types";
import { settings } from "@/settings";
import axios from "axios";

export const getFinancing = async (resourceUid: any) => {
    return (await useApi(UON.SystemUid.odmOrder, `${Paths.order.financing.get(resourceUid)}`).get()).response
}

export async function getOrderFinancingInit(){
    return {
        type: {
            label: '',
            value: ''
        },
        label: '',
        offerReference: '',
        scale: '',
        financingProductPack: {},
        financingOrganization:{},
        associatedParty: {
            orderParty: {
                party: {},
                role: {},
                third: {}
            }
        },
        financedAmountWTax: {
            amount: 0,
            currency: 'EUR'
        },
        financedAmountWoTax: {
            amount: 0,
            currency: 'EUR'
        },
        deposit: {
            amount: 0,
            currency: 'EUR'
        },
        contribution: {
            amount: 0,
            currency: 'EUR'
        },
        firstRent: {
            amount: 0,
            currency: 'EUR'
        },
        eligibleAmountWoTax: {
            amount: 0,
            currency: 'EUR'
        },
        eligibleAmountWTax: {
            amount: 0,
            currency: 'EUR'
        },
        typeRate: undefined,
        numberOfInsurances: undefined,
        financedDuration: undefined,
        numberOfServices: undefined,
        contractMileage: undefined,
        calculatedErAmount: {
            amount: 0,
            currency: 'EUR'
        },
        erAmountRetained: {
                    amount: 0,
                    currency: 'EUR'
        },
        rentAndServicesTc: {
            amount: 0,
            currency: 'EUR'
        },
        rentTc: {
            amount: 0,
            currency: 'EUR'
        }
    }
}

export async function getOrderFinancing(resourceUid: any) {
    const financing = await getFinancing(resourceUid)

    if (!financing) {
        return await getOrderFinancingInit()
    }

    let orderPartyResourceEntity: any = null
    let partyName = ''
    let type = ''
    if (financing.financingOrganization && financing.financingOrganization.resourceUid) {
        orderPartyResourceEntity = await getOrderParty(financing.financingOrganization.resourceUid)
        type = orderPartyResourceEntity?.party?.objectType === "odm.party.party.person.frenchperson"
            ? "party-FrenchPerson"
            : "party-FrenchOrganization"
        partyName = orderPartyResourceEntity?.party?.resourceUid
            ? await getPartyName(orderPartyResourceEntity.party.resourceUid, orderPartyResourceEntity.party.objectType)
            : ''
    }
  
    const typeRate = financing.typeRate && financing.typeRate?.resourceUid ? await getTauxPrimable({rateCode: financing.typeRate?.resourceUid}) : null


    return {
        resourceUid: financing.resourceUid,
        financingStatus: financing.financingStatus,
        type: {
            label: financing.type && financing.type.resourceUid ? financing.type.resourceUid : '',
            value: financing.type && financing.type.resourceUid ? financing.type.resourceUid : '',
        },
        label: financing.label ? financing.label : '',
        offerReference: financing.offerReference ? financing.offerReference : '',
        financingProductPack: {},
        financingOrganization:{
        },
        associatedParty: {
            orderParty: {
                party: {},
                role: {}
            }
        },
        financedAmountWTax: financing.financedAmountWTax && financing.financedAmountWTax.amount ?  financing.financedAmountWTax.amount : 0,
        financedAmountWoTax: financing.financedAmountWoTax && financing.financedAmountWoTax.amount ?  financing.financedAmountWoTax.amount : 0,
        eligibleAmountWoTax: financing.eligibleAmountWoTax && financing.eligibleAmountWoTax.amount ?  financing.eligibleAmountWoTax.amount : 0,
        calculatedErAmount: financing.calculatedErAmount && financing.calculatedErAmount.amount ?  financing.calculatedErAmount.amount : 0,
        erAmountRetained: financing.erAmountRetained && financing.erAmountRetained.amount ?  financing.erAmountRetained.amount : 0,
        rentAndServicesTc: financing.rentAndServicesTc && financing.rentAndServicesTc.amount ?  financing.rentAndServicesTc.amount : 0,
        rentTc: financing.rentTc && financing.rentTc.amount ?  financing.rentTc.amount : 0,
        eligibleAmountWTax: financing.eligibleAmountWTax && financing.eligibleAmountWTax.amount ?  financing.eligibleAmountWTax.amount : 0,
        deposit: financing.deposit && financing.deposit.amount ?  financing.deposit.amount : 0,
        contribution: financing.contribution &&financing.contribution.amount ?  financing.contribution.amount : 0,
        firstRent: financing.firstRent && financing.firstRent.amount ?  financing.firstRent.amount : 0,
        numberOfInsurances: financing.numberOfInsurances ?  financing.numberOfInsurances : '',
        financedDuration: financing.financedDuration !== null ?  financing.financedDuration : '',
        numberOfServices: financing.numberOfServices !== null ?  financing.numberOfServices : '',
        contractMileage: financing.contractMileage !== null ?  financing.contractMileage : '',
        config: {
            partyName: partyName,
            partyType: type,
            partyResourceUid: orderPartyResourceEntity?.party?.resourceUid || null
        },
        typeRate: {
          id: financing.typeRate?.resourceUid || null,
          label: financing.typeRate?.resourceUid
        }
    }
}

export function getTauxPrimable(filter: any): Promise<Picklist> {
  return new Promise<Picklist>(async (resolve, reject) => {
    const url = settings.api_query_url;

    const qc_header: any = {
      qc: {
        queryId: "order-financing-type-rate",
      },
    };
    qc_header.qc.parameters = {
      ...filter,
    };
    const operators = [];
    if (filter && filter.typecode != null) {
      operators.push(
        getOperator(
          "order_order_financing_type_rate",
          "type_code",
          "LIKE",
          globalConfig.formatters.getLikeValue(filter.typecode),
          "type_code"
        )
      );
    }

    if (filter && filter.rateCode != null) {
      operators.push(
        getOperator(
          "order_order_financing_type_rate",
          "id",
          "LIKE",
          globalConfig.formatters.getLikeValue(filter.rateCode),
          "id"
        )
      );
    }

    if (operators.length > 0) {
      qc_header.qc.otherFilters = {
        expressions: [
          {
            and: {
              operators,
            },
          },
        ],
      };
      qc_header.qc.otherOrders = null;
      qc_header.qc.offset = 0;
      qc_header.qc.limit = 50;
    }

    const _headers = headers({
      qc: JSON.stringify(qc_header.qc),
    });

    axios
      .get(url, {
        headers: _headers,
      })
      .then((res) => {
        const response = {
          systemUid: "odm-order",
          items: res.data.map((resItem: any) => {
            return {
              id: resItem.id,
              label: resItem.rate,
            };
          }),
        };
        resolve(response);
      })
  });
}